import React from 'react';
import { Switch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';

import './index.less';

const MAIN_CLASS_NAME = 'ib-switch';
const SMALL_CLASS_NAME = `${MAIN_CLASS_NAME}_small`;

export type IIbSwitchProps = SwitchProps;

const IbSwitch: React.FC<IIbSwitchProps> = ({ className, size, ...otherProps }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);
  size === 'small' && classes.push(SMALL_CLASS_NAME);

  return <Switch {...otherProps} className={classes.join(' ')} />;
};

export default IbSwitch;
